<div class="hardware-search-result">
  @if (isLoadingSearchResults) {
    <app-spinner />
  } @else if (!!loadingVariantsGroupSlug) {
    @if (groupWaitingForVariants(loadingVariantsGroupSlug); as loadingGroup) {
      <div class="search-result-item-grid loading-group">
        <img class="image" [src]="loadingGroup.image ? loadingGroup.image.previewUri : defaultImage" />
        <div class="name-details">
          <div class="manufacturer-name">{{ loadingGroup.manufacturer }}</div>
          <div class="mobile-name">{{ loadingGroup.groupName }}</div>
          <div class="loading-text">Henter produktinformasjon</div>
          <app-spinner />
        </div>
      </div>
    }
  } @else {
    @if (searchResultLength > 0) {
      <div class="display-options">
        <span class="result-header">
          Viser
          <span class="result-count">{{ searchResultLength }}</span>
          {{ isAccessories ? 'produkter' : 'telefoner' }}
        </span>
        <mat-button-toggle-group
          class="display-type-toggle"
          hideSingleSelectionIndicator
          [value]="sortBy"
          (change)="changeSorting($event.value)"
        >
          <mat-button-toggle data-testid="hardware-sorting-high" [value]="SortingTypes.HighestPrice">
            {{ SortingTypes.HighestPrice }}
          </mat-button-toggle>
          <mat-button-toggle data-testid="hardware-sorting-low" [value]="SortingTypes.LowestPrice">
            {{ SortingTypes.LowestPrice }}
          </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-button-toggle-group
          class="display-type-toggle"
          hideSingleSelectionIndicator
          [value]="displayType"
          (change)="changeDisplayType.emit($event.value)"
        >
          <mat-button-toggle data-testid="hardware-displaytype-grid" [value]="SearchDisplayType.Grid">
            Grid
          </mat-button-toggle>
          <mat-button-toggle data-testid="hardware-displaytype-list" [value]="SearchDisplayType.List">
            Liste
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
    @if (searchResultLength === 0) {
      <app-ice-card type="neutral">
        <div class="no-result-card">
          <div class="no-result-message">Beklager, vi kunne ikke finne noe som passet med søkefilter</div>
          @if (canUseManualRegistration() && isManualRegistrationSupported) {
            <a
              class="register-manually"
              data-testid="register-manually-link"
              tabindex="0"
              (click)="registerManually.emit()"
              (keydown.enter)="registerManually.emit()"
            >
              Registrer manuelt
            </a>
          }
        </div>
      </app-ice-card>
    } @else {
      @if (!isAccessories) {
        <div [ngClass]="displayType === SearchDisplayType.Grid ? 'search-results-grid' : 'search-results-list'">
          @for (item of sortedPhoneResults; track item.groupSlug) {
            <a
              data-testid="hardware-search-result-item-link"
              tabindex="0"
              [ngClass]="{
                'search-result-item-list': displayType !== SearchDisplayType.Grid,
                'search-result-item-grid': displayType === SearchDisplayType.Grid,
                'selected-hardware-in-cart': item.isSelected,
              }"
              (click)="itemClicked.emit(item)"
              (keydown.enter)="itemClicked.emit(item)"
            >
              <div class="name-info">
                <p class="manufacturer-name">{{ item.manufacturer }}</p>
                <p class="mobile-name">{{ item.groupName }}</p>
              </div>
              @if (item.simTypeSupport === SimTypeSupport.Esim) {
                <app-ice-img-pill pillText="Kun eSIM">
                  <img class="image" [src]="item.image ? item.image.previewUri : defaultImage" />
                </app-ice-img-pill>
              } @else {
                <img class="image" [src]="item.image ? item.image.previewUri : defaultImage" />
              }
              <div class="terminal-details">
                <div class="price-info">
                  <p class="price-now">
                    {{ item.hardwareOnlyPriceFrom | priceFormat: PriceType.OneTime }}
                  </p>
                  @if (item.hasMobilBytte) {
                    <p *appAllowSettings="[DealerClaimType.EquipmentUpgrade]">
                      Mobilbytte fra
                      <span class="mobilbytte-price">
                        {{ item.bestMonthlyPriceWithMobilbytte | priceFormat: PriceType.Monthly }}
                      </span>
                    </p>
                  }
                  @if (getCampaignSavings(item); as campaignSavings) {
                    <app-ice-badge class="campaign-savings-badge" type="neutral">
                      Kampanje - spar {{ campaignSavings | priceFormat: PriceType.OneTime }}
                    </app-ice-badge>
                  }
                </div>
                <p class="price-with-sub">Med abo fra {{ item.priceFrom | priceFormat: PriceType.OneTime }}</p>
              </div>
            </a>
          }
        </div>
      } @else {
        <div [ngClass]="displayType === SearchDisplayType.Grid ? 'search-results-grid' : 'search-results-list'">
          @for (item of sortedAccessoryResults; track item.offeringId) {
            <a
              data-testid="hardware-search-result-item-link"
              tabindex="0"
              [ngClass]="{
                'search-result-item-grid': displayType === SearchDisplayType.Grid,
                'search-result-item-list': displayType !== SearchDisplayType.Grid,
              }"
              (click)="itemClicked.emit(item)"
              (keydown.enter)="itemClicked.emit(item)"
            >
              <div class="name-info">
                <p class="manufacturer-name">{{ item.manufacturer }}</p>
                <p class="mobile-name">{{ item.name }}</p>
              </div>
              <img class="image" [src]="item.image ? item.image.previewUri : defaultImage" />
              <div class="price-details">
                <div class="price-from">
                  {{ item.priceInformation.price.includingVAT | priceFormat: PriceType.OneTime }}
                </div>
                @if (item.priceFrom) {
                  <div class="accessory-binding-price">
                    Med abo fra {{ item.priceFrom | priceFormat: PriceType.OneTime }}
                  </div>
                }
              </div>
            </a>
          }
        </div>
      }
    }
  }
</div>
